import React from 'react'
import { SvgIcon } from '@mui/material'

export const CopyIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1Zm3 4H8a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H8V7h11v14Z"
      fill="inherit"
    />
  </SvgIcon>
)
